import { render, staticRenderFns } from "./AdditionalShares.vue?vue&type=template&id=7d784fd5&"
import script from "./AdditionalShares.vue?vue&type=script&lang=js&"
export * from "./AdditionalShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports